import React, {useState, useEffect} from 'react'
import ReactJson from 'react-json-view'
import {scanForResults} from 'app/utils/dynamo.js'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';

import waitingArt from 'app/assets/waiting.svg'
 
import LogsTable from 'app/components/LogsTable'
import CountChart from 'app/components/CountChart'
import ChronTab from 'app/components/ChronTab'


const useStyles = makeStyles({
    container: {
      padding: 10,
    },
    root: { 
      flexGrow: 1
    }
  });




function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


export default function FunctionView(props) { 
    const classes = useStyles();
    const [value, setValue] = React.useState(1);
    const [data, setData] = useState([])


    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const downloadLogs = async (refresh = false) => { 
      console.log("starting")
      let result = await scanForResults(undefined, refresh)
      console.log("Done", result["Items"].length)
      let final = result["Items"].filter( x => x.function == props.funcConfig.path).sort((a, b) => (a.timestamp < b.timestamp) ? 1 : -1)
      setData(final)
     }

     useEffect(() => {
      // Run! Like go get some data from an API.
      downloadLogs()
    }, []);

    return(
    <div className={classes.container}>
      <h1>{props.funcConfig.name}
      <IconButton aria-label="refresh" onClick={()=>downloadLogs(true)} className={classes.refreshButton}>
          <RefreshIcon color="primary"/>
        </IconButton>
      </h1> 
      <Paper className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="Logs"/>
          <Tab label="Run" />
          <Tab label="Chron Jobs" />
        </Tabs>
    </Paper>

    <TabPanel value={value} index={0}> <LogsTable data={data} config={props.tableConfig} /> </TabPanel>
    <TabPanel value={value} index={1}> <RunFunction config={props.logsConfig} path={props.funcConfig.path}/> </TabPanel>
    <TabPanel value={value} index={2}> <ChronTab /></TabPanel>  
    </div>)
} 

const callAPI = async (params = {}, funcId) => { 
  let paramString = ''
  Object.entries(params).map( p => { 
    console.log(p)
    paramString += `&${p[0]}=${p[1]}`
  } )

  // console.time('test')
  let url = `https://qu5mkgf451.execute-api.us-east-2.amazonaws.com/Prod/api?&function=${funcId}${paramString}`
  console.log(url);
  let output = await fetch(url)
        .then(res => res.json())
        .catch(err => console.log(err));
  console.timeEnd('test')
  return output
}

const RunFunction = (props) => { 
  const [params, setParam] = useState({})
  const [result, setResult] = useState({})
  const [status, setStatus] = useState('waiting')
  
  const handleChange = (e) => { 
    let newParams = {...params}
    newParams[e.target.id] = e.target.value
    setParam(newParams)
  }

  const handleSubmit = async () => { 
    setStatus('loading')
    console.log(params)
    let resp = await callAPI(params, props.path)
    console.log(resp)
    setResult(resp)
    setStatus('done')
  }

  const clearParams = () => { 
    setParam({})
  }

  const exampleParams = () => { 
    let newParams = {}
    for (const x in props.config) { 
      if(props.config[x].default) { 
        newParams[props.config[x].id] = props.config[x].default
      }
    }
    console.log(newParams)
    setParam(newParams)
  }


  return(
    <div>
    <Grid container spacing={0} alignItems="stretch" style={{height: '100%'}}>

    <Grid item xs={12}> 
    <Paper elevation={3} style={{padding: 8}}>

      <h3>Parameters</h3>
      { props.config?.map( inp => {  
        return(<TextField 
          style={{margin: 10}}
          value={params[inp.id] ?params[inp.id] : "" }
          label={inp.id}
          variant="outlined"
          id={inp.id}
          key={inp.id}
          required={inp.required ? true : false}
          onChange={handleChange}/>)
      })}

      <br/>
      <Button variant="contained" disabled={status=='loading'?true:false} style={{margin: 10}} onClick={clearParams}>Clear</Button>
      <Button variant="contained" disabled={status=='loading'?true:false} style={{margin: 10}} onClick={exampleParams}>Example Parameters</Button>
      <Button variant="contained" disabled={status=='loading'?true:false} style={{margin: 10}} color="primary" onClick={handleSubmit}>Submit</Button>
    </Paper>

    </Grid>
    
    <div style={{width: '100%', textAlign: 'left'}}>

      <h3>Response</h3>
      <Paper style={{backgroundColor: '#0B1C2C', padding: 10}}>
        { status === 'done' ? 
          <ReactJson src={result} theme='harmonic' collapsed={2}/>
          : 
          <div style={{color: 'white', marginTop: 20, marginBottom: 20, textAlign: 'center', height: 80}}>
            { status === 'loading' ?  
              <>
                <p>Loading ...  </p>
                <CircularProgress />
              </>
            : <p style={{color: '#efefef'}}> 🤔 </p>
          }

          </div>
          
        }
      </Paper>
    </div>

    </Grid>
    </div>
  )
}